import { Component, Input } from '@angular/core';
import { IconifyComponent } from '../../iconography/iconify/iconify.component';

@Component({
  selector: 'loading-icon',
  standalone: true,
  imports: [
    IconifyComponent
  ],
  templateUrl: './loading-icon.component.html',
  styleUrl: './loading-icon.component.scss',
})
export class LoadingIconComponent {
  @Input() size = 0;
}
